import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { Edit } from '@material-ui/icons'
import { usePets } from '../../../providers/pets'

import DrawerType from '../../../components/atoms/Drawer'
import EditPet from '../../../components/organisms/EditPet'
import NewPet from '../../../components/organisms/NewPet'

import styles from './styles'

function PetLIst() {
  const { petList, getPets } = usePets()
  const { id } = useParams()

  const [selectPet, setSelectPet] = useState(null)
  const [openDrawer, setOpenDrawer] = useState(false)
  const [openNewPetDrawer, setOpenNewPetDrawer] = useState(false)
  const [showInactive, setShowInactive] = useState(false)

  const { grid, petNew, pet, petEdit, petBox, petImage, drawerBox, petInactive, petBoxInactive, filterContainer, switchLabel } = styles()

  const closeDrawerPet = () => {
    getPets()
    setOpenDrawer(false)
    setOpenNewPetDrawer(false)
  }

  return (
    <Grid item xs={12} className={grid}>
      <div className={filterContainer}>
        <FormControlLabel
          className={switchLabel}
          control={
            <Switch
              checked={showInactive}
              onChange={(event) => setShowInactive(event.target.checked)}
              color="primary"
            />
          }
          label="Mostrar inativos"
        />
      </div>
      
      <DrawerType
        open={openDrawer}
        setDrowerOpen={setOpenDrawer}
        titleHeader="Editar Pet"
        content={
          <div className={drawerBox}>
            <EditPet
              petData={{
                customerId: id,
                callBack: closeDrawerPet,
                // eslint-disable-next-line no-underscore-dangle
                value: { ...selectPet, petId: selectPet?._id },
              }}
            />
          </div>
        }
      />
      <DrawerType
        open={openNewPetDrawer}
        setDrowerOpen={setOpenNewPetDrawer}
        titleHeader="Novo Pet"
        content={
          <div className={drawerBox}>
            <NewPet
              customerData={{ customerId: id, callBack: closeDrawerPet }}
            />
          </div>
        }
      />

      <div className={petBox}>
        <span
          onClick={() => {
            setOpenNewPetDrawer(true)
          }}
          className={petNew}
        >
          +
        </span>
        Novo Pet
      </div>
      {petList &&
        petList
          ?.filter((petData) => {
            // Se showInactive é true, mostra todos os pets
            if (showInactive) return true
            
            // Se showInactive é false, mostra apenas pets ativos
            const statusAttribute = petData.attributes?.find(attr => attr.attributeLabel === 'Status')
            const isInactive = statusAttribute?.value === 'Morto'
            return !isInactive
          })
          ?.sort((a, b) => {
            // Busca o atributo Status para ambos os pets
            const statusA = a.attributes?.find(attr => attr.attributeLabel === 'Status')
            const statusB = b.attributes?.find(attr => attr.attributeLabel === 'Status')
            
            const isInactiveA = statusA?.value === 'Morto'
            const isInactiveB = statusB?.value === 'Morto'
            
            // Pets ativos primeiro (false < true), depois pets inativos
            if (isInactiveA !== isInactiveB) {
              return isInactiveA - isInactiveB
            }
            
            // Se ambos têm o mesmo status, ordena por nome
            return a.name.localeCompare(b.name)
          })
          ?.map((petData) => {
            // Busca o atributo Status nos atributos do pet
            const statusAttribute = petData.attributes?.find(attr => attr.attributeLabel === 'Status')
            const isInactive = statusAttribute?.value === 'Morto'
            
            return (
              <div key={petData.name} className={isInactive ? petBoxInactive : petBox}>
                <span
                  key={petData._id}
                  onClick={() => {
                    setSelectPet(petData)
                    setOpenDrawer(true)
                  }}
                  className={isInactive ? petInactive : pet}
                >
                  {petData.petImg && (
                    <img
                      src={petData.petImg}
                      alt={petData.name}
                      className={petImage}
                      style={isInactive ? { opacity: 0.6 } : {}}
                    />
                  )}
                  {!petData.petImg && petData.name.charAt(0)}
                  <dd className={petEdit}>
                    <Edit />
                  </dd>
                </span>
                {petData.name}
                </div>
            )
          })}
    </Grid>
  )
}

export default PetLIst
